// extracted by mini-css-extract-plugin
export var copy = "hem-module--copy--429de";
export var detail_btn = "hem-module--detail_btn--84bb3";
export var details = "hem-module--details--3d5b3";
export var drop = "hem-module--drop--6e42d";
export var drop_btn = "hem-module--drop_btn--a1453";
export var drop_opts = "hem-module--drop_opts--0f46c";
export var hem = "hem-module--hem--1884c";
export var hem_btns = "hem-module--hem_btns--b0a95";
export var hem_more = "hem-module--hem_more--3ce8b";
export var hem_note = "hem-module--hem_note--66668";
export var hem_toggle = "hem-module--hem_toggle--65d3d";
export var img = "hem-module--img--95b65";
export var label = "hem-module--label--897dd";
export var modal = "hem-module--modal--a18d0";
export var svg_plus = "hem-module--svg_plus--41e89";